import { useState, useRef } from "react";
import { IconButton } from "@mui/material";
import type { MediaItemDetails } from "../../types/mediaLibraryTypes";
import PlayCircleFilledWhiteOutlinedIcon from "@mui/icons-material/PlayCircleFilledWhiteOutlined";

import classes from "./MediaPreview.module.less";

export const VideoPreview = ({ mediaItem }: { mediaItem: MediaItemDetails }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  const mediaPlayIcon = () => {
    return (
      <IconButton
        className={classes.playIcon}
        variant="contained"
        size={"medium"}
        color={"secondary"}
        onClick={handlePlayClick}
      >
        <PlayCircleFilledWhiteOutlinedIcon />
      </IconButton>
    );
  };

  const handlePlayClick = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };

  return (
    <>
      <video
        ref={videoRef}
        controls
        width="860"
        poster={mediaItem?.previewUrl}
        style={{ height: "100%", position: "relative" }}
        onPlay={() => setIsPlaying(true)}
        onPause={() => setIsPlaying(false)}
        onEnded={() => setIsPlaying(false)}
      >
        <source src={mediaItem?.videoPreviewUrl} type="video/mp4" />
      </video>
      {!isPlaying && mediaPlayIcon()}
    </>
  );
};
